import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'sabis-ngx-x-icon',
  template: `
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"	 width="9.954px" height="10.023px" viewBox="0 0 9.954 10.023" enable-background="new 0 0 9.954 10.023" xml:space="preserve"><g>	<g>		<path fill="#B6ADA4" d="M9.745,8.798L5.983,5.011l3.763-3.788c0.276-0.28,0.276-0.732,0-1.012c-0.277-0.282-0.728-0.282-1.006,0            L4.977,3.999L1.214,0.211c-0.278-0.282-0.729-0.282-1.008,0c-0.275,0.279-0.275,0.731,0,1.012L3.97,5.011L0.207,8.798            c-0.276,0.282-0.276,0.734,0,1.014c0.14,0.139,0.321,0.211,0.503,0.211s0.365-0.072,0.504-0.211l3.763-3.788L8.74,9.812            c0.139,0.139,0.321,0.211,0.503,0.211s0.363-0.072,0.502-0.211C10.023,9.533,10.023,9.081,9.745,8.798z"/>	</g></g></svg>
`,
})
export class SabisNgxXIconComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }
}
